import { EditorType, type InitializeData } from '@/types/feedback';

import { WorkbenchPageClient } from './WorkbenchPageClient';
import { WorkbenchPageLoader } from './WorkbenchPageLoader';

interface WorkbenchPageProps {
  commentId?: string;
  sealedContext?: string;
  targetUrl: string;
  metaSiteId: string;
  feedbackId: string;
  editorType?: EditorType;
  initialData?: InitializeData;
  allowAnonymousModal?: boolean;
  sidebarReadOnly?: boolean;
  isPartner?: boolean;
  agencyName?: string;
}

export function WorkbenchPage({
  commentId,
  sealedContext,
  targetUrl,
  metaSiteId,
  feedbackId,
  editorType,
  initialData,
  allowAnonymousModal = false,
  sidebarReadOnly = false,
  isPartner = false,
  agencyName,
}: WorkbenchPageProps) {
  return (
    <div className="relative flex h-screen flex-col overflow-hidden">
      <WorkbenchPageClient
        commentId={commentId}
        sealedContext={sealedContext}
        targetUrl={targetUrl}
        metaSiteId={metaSiteId}
        feedbackId={feedbackId}
        editorType={editorType}
        initialData={initialData}
        loader={<WorkbenchPageLoader />}
        allowAnonymousModal={allowAnonymousModal}
        sidebarReadOnly={sidebarReadOnly}
        isPartner={isPartner}
        agencyName={agencyName}
      />
    </div>
  );
}
